export const EVENT_TYPES = {
	UI: 'ui',
	CTA: 'cta',
};

export const EVENT_SECTIONS = {
	SIDEBAR: 'sidebar',
	INSTALL_MODAL: 'ally install popup',
};

class GoogleAnalyticsEvent {
	constructor() {
		this.BASE_EVENT = {
			event: 'fireEvent',
			event_name: 'element_click',
			type: undefined,
			section: undefined,
			element_name: undefined,
			outcome: undefined,
			english_text: undefined,
			level_1: undefined,
			level_2: window?.ea11yScannerData?.violationsTotal || 0,
			additional_description: location.origin,
		};
	}

	setType(eventType) {
		this.BASE_EVENT.type = eventType;

		return this;
	}

	setSection(section) {
		this.BASE_EVENT.section = section;

		return this;
	}

	setElementName(elementName) {
		this.BASE_EVENT.element_name = elementName;

		return this;
	}

	setOutcome(outcome) {
		this.BASE_EVENT.outcome = outcome;

		return this;
	}

	setEnglishText(text) {
		this.BASE_EVENT.english_text = text;

		return this;
	}

	setLevelOne(value) {
		this.BASE_EVENT.level_1 = value;

		return this;
	}

	getEvent() {
		Object.keys(this.BASE_EVENT).forEach((key) => {
			if (typeof this.BASE_EVENT[key] === 'undefined') {
				delete this.BASE_EVENT[key];
			}
		});

		return this.BASE_EVENT;
	}
}

export default GoogleAnalyticsEvent;
